import { Component, OnInit, Renderer2 } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
    providers: [OrderPipe] // Add this line

})
export class AdminLayoutComponent implements OnInit {
  public _opened: boolean = false;
  public _modeNum: number = 1;
  public _animate: boolean = true;
  public _MODES: Array<string> = ['over', 'push', 'slide'];
  public _dock: boolean = true;
  public toggleSideBar() {
    this._opened = !this._opened;
  }
  constructor(private renderer: Renderer2) { }
  ngOnInit() {

  }
  public close() {
    this.renderer.addClass(document.body, "menu-close")
  }
  public _onOpen() {
    this.renderer.removeClass(document.body, "menu-close")
  }
}
